module.exports = __webpack_public_path__ + "img/email.eb7c320e.png";